import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StoreGroupsSearchFilterQuery } from "../../models/filters/storeGroups/StoreGroupsSearchFilterQuery";
import { StoreSearchFilterQuery } from "../../models/filters/stores/StoreSearchFilterQuery";
import { StoresApi } from "apis/StoresApi";
import { StoreGroupsApi } from "apis/StoreGroupsApi";
import { StoreGroupTree } from "models/dbModels/other/StoreGroupTree";
import { StoreExtended } from "models/dbModels/stores/Store";

export const getManageGroupsStores = createAsyncThunk("manageGroupsSlice/getManageGroupsStores", async (params: StoreSearchFilterQuery) => {
    const response = await StoresApi.Search(params);
    return response.data;
});

export const getManageGroupsStoreTree = createAsyncThunk("manageGroupsSlice/getManageGroupsStoreTree", async (params?: StoreGroupsSearchFilterQuery) => {
    params = params ?? {};
    params = { ...params, limit: params.limit || 100, offset: params.offset || 0 };
    const response = await StoreGroupsApi.SearchTree(params);
    return response.data;
});

type InitialStateType = {
    keyword: string;
    loading: boolean;
    tree: StoreGroupTree[];
    stores: StoreExtended[];
    selectedRows: any[];
    deselectedRows: any[];
    error: string;
};

const initialState: InitialStateType = {
    keyword: "",
    loading: false,
    tree: [],
    stores: [],
    selectedRows: [],
    deselectedRows: [],
    error: "",
};

const manageGroupsSlice = createSlice({
    name: "manageGroupsSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateManageGroupsField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanManageGroupsDetails: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getManageGroupsStores.pending, (state) => {
            state.loading = true;
            state.stores = [];
            state.error = "";
        });
        builder.addCase(getManageGroupsStores.fulfilled, (state, action) => {
            state.loading = false;
            state.stores = action.payload.data ? action.payload.data : [];
        });
        builder.addCase(getManageGroupsStores.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
        builder.addCase(getManageGroupsStoreTree.fulfilled, (state, action) => {
            state.tree = action.payload.data ? action.payload.data : [];
        });
    },
});

export const { updateManageGroupsField, cleanManageGroupsDetails } = manageGroupsSlice.actions;

export default manageGroupsSlice.reducer;